import { useEffect, useState } from "react";
import Lenis from "lenis";
import Intro from "./components/Intro";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Konzept from "./components/Konzept";
import Programm from "./components/Programm";
import InstagramSection from "./components/InstagramSection";
import Galerie from "./components/Galerie";
import Reservation from "./components/Reservation";
import Footer from "./components/Footer";

export default function App() {
  const [introDone, setIntroDone] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf = 0;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onClick = (e) => {
      const a = e.target.closest?.('a[href^="#"]');
      if (!a) return;
      const href = a.getAttribute("href");
      if (!href || href.length < 2) return;
      const el = document.querySelector(href);
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(el, { offset: -64 });
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div id="top" className="min-h-screen bg-paper text-ink">
      <span className="grain-overlay" aria-hidden="true" />
      <Intro onDone={() => setIntroDone(true)} />
      <Navbar />
      <main>
        <Hero start={introDone} />
        <Marquee />
        <Konzept />
        <Programm />
        <InstagramSection />
        <Galerie />
        <Reservation />
      </main>
      <Footer />
    </div>
  );
}
